import React from "react";
import Text from "../text";
import {
  StyledUrgencyCard,
  PhoneContainer,
  DesktopLink,
  MobileLink,
  TextContainer,
} from "./styled-components";
import { ReactComponent as UrgencyIcon } from "../../assets/icons/urgency.svg";

const UrgencyCard = ({ title, phoneNumber, href }: UrgencyCardProps) => {
  return (
    <StyledUrgencyCard>
      <TextContainer>
        <Text size="20px" weight={700}>
          {title}
        </Text>
      </TextContainer>
      <DesktopLink>
        <PhoneContainer>
          <UrgencyIcon />
          <a href={href} target="_blank" rel="noreferrer">
            <Text size="24px" weight={700} color="red" underline>
              {phoneNumber}
            </Text>
          </a>
        </PhoneContainer>
      </DesktopLink>
      <MobileLink>
        <PhoneContainer>
          <UrgencyIcon />
          <a href={`tel:${phoneNumber}`} target="_blank" rel="noreferrer">
            <Text size="24px" weight={700} color="red" underline>
              {phoneNumber}
            </Text>
          </a>
        </PhoneContainer>
      </MobileLink>
    </StyledUrgencyCard>
  );
};

export default UrgencyCard;
